import React, { useEffect, useState } from "react";
import l from "components/util/l";

const PROTOTYPE_SANDBOX =
  "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads";

const PrototypeFrame = ({
  hasPrototype = true,
  isLoadError = false,
  className = "",
  documentUrl,
  frameId,
  frameRef = null,
  style = {},
}) => {

  // The frame reports its own load. Until it fires, the prototype is still parsing and
  // running its scripts on this thread, which is the stretch that used to look like the
  // app had died: the old spinner cleared as soon as the HTML arrived, right before it.
  const [isFrameReady, setIsFrameReady] = useState(false);

  useEffect(() => setIsFrameReady(false), [documentUrl]);

  return (
    <div
      className={`position-relative ${className}`}
      style={{ backgroundColor: "#ffffff", ...style }}
    >
      {!hasPrototype && (
        <div className="h-100 d-flex flex-column justify-content-center align-items-center text-center text-muted px-4">
          <i className="fas fa-code fa-3x mb-3 opacity-25"></i>
          <div>{l("Aún no hay prototipos generados para esta vista.%PA581")}</div>
        </div>
      )}

      {hasPrototype && isLoadError && (
        <div className="h-100 d-flex flex-column justify-content-center align-items-center text-center text-danger px-4">
          <i className="fas fa-exclamation-triangle fa-2x mb-3"></i>
          <div>{l("No fue posible cargar este prototipo.%PA585")}</div>
        </div>
      )}

      {hasPrototype && !isLoadError && (
        <>
          {documentUrl && (
            <iframe
              id={frameId}
              ref={frameRef}
              title="prototype-preview"
              className="border-0 w-100 h-100 d-block"
              src={documentUrl}
              sandbox={PROTOTYPE_SANDBOX}
              scrolling="auto"
              style={{ backgroundColor: "#ffffff", visibility: isFrameReady ? "visible" : "hidden" }}
              onLoad={() => setIsFrameReady(true)}
            />
          )}

          {!isFrameReady && (
            <div
              className="d-flex flex-column justify-content-center align-items-center text-center text-muted px-4 bg-white"
              style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }}
            >
              <i className="fas fa-spinner fa-spin fa-2x mb-3"></i>
              <div>{l("Cargando prototipo...%PA582")}</div>
            </div>
          )}
        </>
      )}
    </div>
  );

};

export default PrototypeFrame;
